if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.updateATCButton = this.updateATCButton.bind(this);

      this.form = this.querySelector('form');
      this.isPreOrder = this.dataset.isPreOrder === 'true';
      this.isBundle = this.dataset.isBundle === 'true';
      this.isPreorderBundle = this.dataset.isPreorderBundle === 'true';
      this.hasOnlyDefaultVariant = this.dataset.hasOnlyDefaultVariant === 'true';
      this.variantId = this.dataset.variantId;
      this.section = this.dataset.section;

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');

      if (this.isPreOrder || this.isPreorderBundle) {
        // mutationObserver for buy now button
        this.observerConfig = { attributes: true, childList: true, subtree: true, characterData: true };
        this.observer = new MutationObserver(this.updateATCButton);
        // Start observing the target node for configured mutations
        this.observer.observe(this.form, this.observerConfig);

        this.updateATCButton();
      }
    }

    updateATCButton() {
      this.atcButton = this.querySelector('.product-form__submit > span');
      const canAddToCart = this.atcButton.innerText.toLowerCase() === window.variantStrings.addToCart.toLowerCase();

      if (!canAddToCart) return;
      this.observer.disconnect();
      this.atcButton.innerText = 'Pre-Order Now';
      this.observer.observe(this.form, this.observerConfig);
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      if (evt.target.closest(".upsell")) { this.cartNotification.setActiveElement(document.activeElement) };

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const isValid = this.validateInventory();

      if (!isValid) {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        return;
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          let open = evt.target.closest(".upsell") ? false : true
          this.cartNotification.renderContents(response, open);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          this.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          this.dispatchEvent(new CustomEvent('cart:updateCloseOut', { bubbles: true }));
          // If upsell section present, refresh cart from cart add
          if (evt.target.closest(".upsell")) { document.querySelector('cart-items').getNewCart() }
        });
    }

    validateInventory() {
      const selectedQuantity = parseInt(document.getElementById(`Quantity-${this.section}`).value || 1, 10);
      const variantSelect = document.querySelector(`variant-selects[data-section="${this.section}"], variant-radios[data-section="${this.section}"]`);
      const bundleInfo = document.querySelector(`#BundleInfo-${this.section}`);

      if (this.isBundle) {
        let isValid = true;
        let isAvailable = bundleInfo && bundleInfo.available;
        if (!isAvailable) return false;

        let formData = JSON.parse(serializeForm(this.form));
        let atcVariants = this.expandBundleFormProperties(formData.properties);

        for (const [variantId, bundle] of Object.entries(atcVariants)) {
          let variant = window[this.section].variantsById[variantId];
          variant.safetyStock = variant.safety_stock;
          const availableInventory = window.inventoryValidator.getSellableInventoryForVariant(variant);

          if (availableInventory < (selectedQuantity * bundle.quantity)) {
            const message = window.cartStrings.bundleQuantityError;
            this.handleErrorMessage(message);
            isValid = false;
            break;
          }
        }

        return isValid;

      } else {
        // products without variants
        if (this.hasOnlyDefaultVariant && this.variantId) {
          this.currentVariant = window[this.section].variantsById[this.variantId];
        } else if (!this.hasOnlyDefaultVariant) {
          if (variantSelect && variantSelect.currentVariant) {
            this.variantId = variantSelect.currentVariant.id;
            this.currentVariant = window[this.section].variantsById[this.variantId]
          }
        }

        this.currentVariant.safetyStock = window[this.section].safetyStock;
        const availableInventory = window.inventoryValidator.getSellableInventoryForVariant(this.currentVariant);

        if (availableInventory < selectedQuantity) {
          const message = window.cartStrings.quantityError.replace('[quantity]', availableInventory);
          this.handleErrorMessage(message);
        }

        return availableInventory >= selectedQuantity;
      }
    }

    expandBundleFormProperties(bundleData) {
      const expandedData = {};

      // get quantity info for each line item in the bundle
      let bundleLineItemData = {};
      let bundleLineItems = Object.entries(bundleData).filter(([key]) => key.includes('_line_item_data_for_product_'));

      bundleLineItems.forEach(lineItem => {
        let productId = lineItem[0].replace('_line_item_data_for_product_', '');
        let data = JSON.parse(lineItem[1]);
        let quantity = data['quantity in bundle'];
        let safetyStock = data['safety stock'];
        bundleLineItemData[productId] = bundleLineItemData[productId] || { "quantity": quantity, "safetyStock": safetyStock };
      })

      // add each variant in the bundle to expandedData
      let bundleItemVariants = Object.entries(bundleData).filter(([key]) => key.includes('_bundle_selectedVariantOnProduct_'));

      bundleItemVariants.forEach(variant => {
        let productId = variant[0].replace('_bundle_selectedVariantOnProduct_', '');
        let variantId = variant[1];

        expandedData[variantId] = expandedData[variantId] || { quantity: 0, productId: productId };
        expandedData[variantId].quantity += bundleLineItemData[productId].quantity;
        expandedData[variantId].safetyStock = bundleLineItemData[productId].safetyStock;
      });

      return expandedData;
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
